export function FloatFooter() {
  return (
    <footer className="w-full pt-6 px-12 text-center text-white">
      <div
        class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
        <div class="flex flex-row items-center justify-center gap-4 mr-2">
          <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
            <img src="https://galilea.co/png/colombia-fintech.png" class="h-4 w-auto object-contain"
              alt="colombia fintech" />
          </div>

          <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
            <img src="https://galilea.co/png/sic.png" class="h-4 w-auto object-contain brightness-0 invert opacity-90"
              alt="Superintendencia de Industria y Comercio" />
          </div>
        </div>
        <span
          class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2" style={{ fontSize: "10px" }}>
          Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
          Colombia con NIT: 901.582.748-5
        </span>
      </div>
    </footer>
  );
}
